exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-8e36527e] .el-loading-mask{background-color:#1e4960!important;opacity:1!important}.circle-point[data-v-8e36527e]{width:12px;height:12px;border-radius:6px}", ""]);

// exports
